// extracted by mini-css-extract-plugin
export var container = "_91-0";
export var icon = "_91-1";
export var text = "_91-2";